import { Component } from '@angular/core';
import { HintBaseComponent } from '@shared/modules/hint/components/hint-base/hint-base.component';

@Component({
  selector: 'app-svg-hint',
  templateUrl: './svg-hint.component.html',
  styleUrls: ['./svg-hint.component.scss'],
})
export class SvgHintComponent extends HintBaseComponent {}
